export const APP_VERSION = '3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

// Fixed brand surface behind the auth pages. Same in both themes on purpose,
// so the white logo and identity colours always sit on dark ground.
export const BRAND_PANEL_BG = '#0B1A22';

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK'
};

// RED and CYAN are the logo's identity hues. They are overlay/canvas colors only
// (floorplan polygons, heatmap fills) — as label-bearing UI fills they measure
// 2.94:1 and 1.71:1 on white, below the WCAG floor. UI_* below hold the same hues
// at a lightness that clears 4.5:1, and are what the theme palette references.
export const COLORS = {
  RED: '#FF634D',
  CYAN: '#4BD5FE',
  UI_CYAN: '#0F7FAE',
  UI_CYAN_DARK: '#0B6E96',
  UI_CYAN_ON_DARK: '#4BBBE4',
  UI_CORAL: '#D93E22',
  UI_CORAL_ON_DARK: '#FF8B6B',
  WHITE: '#FFFFFF',
  GREY: '#A4A4A4',
  BLUE: '#178DC7',
  INDIGO: '#3F51B5',
  AMBER: '#F1C40F',
  GREEN: '#24B800',
  ORANGE: '#f45100',
  WEEK53: '#8E44AD'
};

// Categorical chart series, assigned in fixed order and never cycled. Both sets
// pass lightness-band, chroma-floor, colourblind-separation and surface-contrast
// checks against their own ground. A 7th series folds into "Other".
export const SERIES_LIGHT = [
  '#0F7FAE',
  '#E05A3A',
  '#6B4FBB',
  '#1F8A5F',
  '#A86A00',
  '#A8326B'
];

export const SERIES_DARK = [
  '#2E9CC4',
  '#EA6544',
  '#9878DC',
  '#34A96F',
  '#BC8722',
  '#D95890'
];

// A comparison series is the same metric at a different time, not a different
// entity, so it takes a recessive neutral rather than a rival hue.
export const SERIES_COMPARISON = { light: '#93A6B3', dark: '#55707F' };

export const TABLEAU10 = [
  '#4E79A7',
  '#F28E2B',
  '#E15759',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
  '#9C755F',
  '#BAB0AC'
];
